import React from 'react'
import './Footer.css'

const Footer = () => {
    return (
        <footer className="footer" >
            <span>R2S Version v1.0.0 (Department of Foreign Affairs and Trade. ap-southeast-2) </span>
        </footer>
    )
}

export default Footer